import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import * as forecastBatchCrud from "../../../../crud/forecastBatch.crud";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import { Badge } from "react-bootstrap";
import ProjectOrderBatchModal from './ProjectOrderBatchModal/ProjectOrderBatchModal';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, contract) => {
    const formFields = [];
    
    if (fields.Subject.visible) {
        formFields.push({
            caption: fields.Subject.label,
            dataField: 'subject',
            required: fields.Subject.required,
            dataType: 'string'
        })
    }

    if (fields.ForecastDate.visible) {
        formFields.push({
            caption: fields.ForecastDate.label,
            dataField: 'forecastdatedisplay',
            required: fields.ForecastDate.required,
            dataType: 'date'
        })
    }

    if (fields.Details.visible) {
        formFields.push({
            caption: fields.Details.label,
            dataField: 'description',
            required: fields.Details.required,
            dataType: 'long-string'
        })
    }

    if (fields.Type.visible) {
        formFields.push({
            caption: fields.Type.label,
            dataField: 'replycomment',
            required: fields.Type.required,
            dataType: 'list',
            options: {
                dataSource: fields.Type.clauses,
                valueExpr: 'display',
                displayExpr: 'display'
            }
        })
    }

    if (fields.CostForecast.visible) {
        formFields.push({
            caption: fields.CostForecast.label,
            dataField: 'newcostforecast',
            required: fields.CostForecast.required,
            dataType: 'money'
        });
    }

    if (fields.ProjectOrders.visible) {
        formFields.push({
            caption: fields.ProjectOrders.label,
            dataField: 'projectorderid',
            required: fields.ProjectOrders.required,
            dataType: 'integer',
        });
    }

    return formFields;
}

class ForecastBatchList extends BaseListPage {
    constructor(props) {
        super(props);
        this.state = {
            notifications: null,
            showWizard: false
        };

        this.multipleProjectOrderWizardEnabled = props.workflowItem.userFilters.mainNotice.createAllowed;

        this.batchForecastForPackagedContractEnabled = props.workflowsQA['72'] && props.contract.ispackaged;

        this.additionalButtons = [];
        if (this.multipleProjectOrderWizardEnabled) {
            this.additionalButtons.push(
                {
                    location: "after",
                    locateInMenu: "auto",
                    widget: "dxButton",
                    options:
                    {
                        icon: "plus",
                        onClick: () => { this.setState({ showWizard: true }) },
                        text: "Create Batch",
                    }
                }
            );
        }

        this.columns = [
            { caption: "Reference ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.CREATED_DATE", dataField: "createdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby" },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "communicateddate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
        ];

        this.batchFormFields = getBatchFormFields(props.workflowItem.fields, props.contract);
    }

    componentDidMount() {
        super.componentDidMount();
        this.loadForecastBatches();
        if (window.location.hash === "#wizard") {
            //remove hash from URL
            window.history.replaceState("", document.title, window.location.pathname);
            this.setState({ showWizard: true })
        }
    }

    loadForecastBatches = async () => {
        const contractid = this.props.contract.contractid;
        const { data: responseObj } = await forecastBatchCrud.getRegisterList(contractid, this.props.workflowItem.config.currentModelType);
        let listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
                responseObj :
                responseObj.filter(ntf => ntf.communicated === true);
        this.setState({ notifications: listData });
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }

    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.forecastbatchid;
    }

    calculateStatusValue = (rowData) => {
        if (rowData.status) {
            return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
        }
        else {
            return "";
        }
    }

    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        switch (cellInfo.data.status) {
            case 'NOT_COMMUNICATED':
                badgeVariant = 'secondary';
                break;
            case 'COMMUNICATED':
                badgeVariant = 'success';
                break;
            default:
                break;
        }
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }

    onWizardClosed = () => {
        this.setState({ showWizard: false });
        this.loadForecastBatches();
    }

    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={this.batchForecastForPackagedContractEnabled && this.props.workflowItem.userFilters.mainNotice.createAllowed}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={forecastBatchCrud.importForecastBatches}
                        batchDeleteEndpoint={forecastBatchCrud.deleteForecastBatchDrafts}
                        batchCommunicateEndpoint={forecastBatchCrud.communicateForecastBatchDrafts}
                        onBatchRecordsUpdated={this.loadForecastBatches}
                        //BATCH OPS
                        title={this.props.workflowItem.title}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="forecastbatchid"
                        columns={this.columns}
                        //gridName={`${this.props.workflowItem.id}List`}
                        additionalToolbarItems={this.additionalButtons}
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        workflowItem={this.props.workflowItem}
                    />
                    {this.multipleProjectOrderWizardEnabled && (
                        <ProjectOrderBatchModal
                            {...this.props}
                            visible={this.state.showWizard}
                            onClose={this.onWizardClosed}
                        />
                    )}
                </PortletBody>
            </Portlet>
        );
    }
}

export default withListPageProps(ForecastBatchList);